import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import PropTypes from 'prop-types';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import './sidebarMenu.css';

export const SidebarMenu = ({ menuData }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const [expanded, setExpanded] = useState(null);

  useEffect(() => {
    menuData?.forEach((menu, index) => {
      menu?.sub_menu?.forEach((sub) => {
        if (location?.pathname === sub?.url) {
          setExpanded(index);
        }
      });
    });
  }, [location.pathname, menuData]);

  const handleClick = (url, index, hasSubMenu) => {
    if (hasSubMenu) {
      setExpanded(expanded === index ? null : index);
    } else {
      navigate(url);
    }
  };

  return (
    <div className="sidebar-menu">
      {menuData?.map((menu, index) => (
        <Accordion
          key={menu?.sub_menu?.length > 0 ? menu?.name : menu?.url}
          expanded={expanded === index}
          onChange={() => handleClick(menu?.url, index, menu?.sub_menu?.length > 0)}
        >
          <AccordionSummary
            aria-controls={`panel${index}-content`}
            id={`panel${index}-header`}
            sx={{
              padding: '0px 16px',
              height: '64px',
              cursor: 'pointer',
              justifyContent: 'space-between',
              display: 'flex',
              alignItems: 'center',
              backgroundColor: (location?.pathname === menu?.url ||  location?.pathname?.includes('promotions') && menu?.name?.toLowerCase()?.includes('promotions')) ? '#52525b' : 'black',
              color: 'white',
              ':hover': { backgroundColor: '#52525b' },
              transition: 'background-color 0.3s'
            }}
          >
            <Typography sx={{ flexGrow: 1 }}>{menu?.name}</Typography>
            {menu?.sub_menu?.length > 0 && (expanded === index ? <ExpandLessIcon sx={{ color: 'white' }} /> : <ExpandMoreIcon sx={{ color: 'white' }} />)}
          </AccordionSummary>
          {menu?.sub_menu?.length > 0 && (
            <AccordionDetails sx={{ padding: '0px 0px 0px 16px', backgroundColor: 'black' }}>
              {menu?.sub_menu?.map((sub) => (
                <div
                  key={sub?.url}
                  className={`sub-menu-item ${location?.pathname === sub?.url ? 'active' : ''}`}
                  role="button"
                  tabIndex={0}
                  onClick={() => navigate(sub?.url)}
                  onKeyPress={(e) => {
                    if (e.key === 'Enter' || e.key === ' ') {
                      navigate(sub?.url);
                    }
                  }}
                  style={{
                    padding: '8px 16px',
                    height: 'auto',
                    minHeight: '48px',
                    cursor: 'pointer',
                    display: 'flex',
                    alignItems: 'center',
                    backgroundColor: location?.pathname === sub?.url ? '#52525b' : 'black',
                    color: 'white',
                    transition: 'background-color 0.3s',
                  }}
                  onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = '#3b3b48')}
                  onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = location?.pathname === sub?.url ? '#52525b' : 'black')}
                >
                  {sub?.name}
                </div>
              ))}
            </AccordionDetails>
          )}
        </Accordion>))}
    </div>
  );
};

SidebarMenu.propTypes = {
  menuData: PropTypes.arrayOf(
    PropTypes.shape({
      url: PropTypes.string,
      name: PropTypes.string.isRequired,
      sub_menu: PropTypes.arrayOf(
        PropTypes.shape({
          url: PropTypes.string,
          name: PropTypes.string.isRequired
        })
      )
    })
  ).isRequired
};
